export default {"src":"/_next/static/media/automate-2.c9ba0086.svg","height":72,"width":91};